module.exports = __webpack_public_path__ + "static/img/left_nor.d3be8e9e.png";